import { render, staticRenderFns } from "./Scaffold.vue?vue&type=template&id=45774666&"
import script from "./Scaffold.vue?vue&type=script&lang=ts&"
export * from "./Scaffold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports